import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex';
import { formHandlingMixin } from '@/mixins/formHandlingMixin';

export function usePatientData(dataStore, swal, resourceApi) {
    const store = useStore();
    const viewAsCard = ref(true);
    const itemsPerPage = ref(9);
    const isLoading = ref(false);

    const totalFilteredItems = computed(() => store.getters[`${dataStore}/totalItems`]);
    const filteredItems = computed(() => store.getters[`${dataStore}/items`] || []);
    const currentPage = computed(() => store.getters[`${dataStore}/currentPage`]);
    const lastPage = computed(() => store.getters[`${dataStore}/lastPage`]);

    const fetchItems = async (page = 1) => {
        if (isLoading.value) return;
        isLoading.value = true;
        try {
            await store.dispatch(`${dataStore}/fetchRecords`, {
                resource: resourceApi,
                options: {
                    page,
                    search: '',
                    itemsPerPage: itemsPerPage.value,
                    sortColumn: 'updated_at',
                    sortOrder: 'desc',
                }
            });
            await nextTick();
        } catch (error) {
            console.error('Error al obtener los registros:', error);
        } finally {
            isLoading.value = false;
        }
    };

    const deleteItem = async ({ id, fullname }) => {
        try {
            await formHandlingMixin.methods.deleteEntity.call({
                $store: store,
                $swal: swal,
                $emit: () => { },
            }, id, fullname, dataStore, resourceApi);
            fetchItems(currentPage.value);
        } catch (error) {
            console.error('Error eliminando el registro:', error);
        }
    };

    const applyFilter = ({ search, selectedFilter }) => {
        store.dispatch(`${dataStore}/fetchRecords`, {
            resource: resourceApi,
            options: {
                page: 1,
                search,
                itemsPerPage: itemsPerPage.value,
                sortColumn: selectedFilter,
                sortOrder: selectedFilter === 'created_at' || selectedFilter === 'updated_at' ? 'desc' : 'asc',
            }
        });
    };

    const updateItemsPerPage = (newItemsPerPage) => {
        itemsPerPage.value = newItemsPerPage;
        fetchItems(1);
    };

    const updateViewAsCard = (view) => {
        viewAsCard.value = view;
    };

    const changePage = (page) => {
        store.commit(`${dataStore}/SET_CURRENT_PAGE`, page);
        fetchItems(page);
    };

    return {
        viewAsCard,
        itemsPerPage,
        isLoading,
        totalFilteredItems,
        filteredItems,
        currentPage,
        lastPage,
        fetchItems,
        deleteItem,
        applyFilter,
        updateItemsPerPage,
        updateViewAsCard,
        changePage
    };
}